import axios from "axios";

// создаём инстанс
const api = axios.create({
  baseURL: "https://nagamigames.ru/api",
});

// перехватчик запросов (добавляет токен)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// перехватчик ответов (обработка ошибок 401)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("⛔ Unauthorized, please login again");
      // можно редиректить на /login или вызвать logout
    }
    return Promise.reject(error);
  }
);

export default api;
